import React from "react"

import Compositions from "../compositions/Compositions"
import { SORTING_OUTPUT_CONFIG } from "../compositions/CompositionTypeContext"

const SortingOutput = () => <Compositions config={SORTING_OUTPUT_CONFIG} />

export default SortingOutput
